import React, { useEffect, useState } from "react";
import {
  Layout,
  Menu,
  Row,
  Col,
  Badge,
  Typography,
  Dropdown,
  Modal,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  DownOutlined,
} from "@ant-design/icons";
import HomeIcon from "../../Icons/HomeIcon";
import {
  sellerMenuItems,
  sellerRoutes,
  sellerMenuItemsInActive,
} from "./../SellerSidebar/menuItems";
import { ReactComponent as Logo } from "../../../assets/seller/icons/mobapartner.svg";
import OrderIcon from "../../Icons/OrderIcon";
import CustomerIcon from "../../Icons/CustomerIcon";
import SellerIcon from "../../Icons/SellerIcon";
import ReturnIcon from "../../Icons/ReturnIcon";
import RenderIcons from "./../SellerSidebar/RenderIcons";
import RequestIcon from "../../Icons/RequestIcon";
import SettingsIcon from "../../Icons/SettingsIcon";
import ReportsIcon from "../../Icons/ReportsIcon";
import { Link, useLocation, useParams } from "react-router-dom";
import "./../SellerSidebar/Sidebar.css";
import { MobIcon } from "../../Icons/MobIcon";
import ReturnExchange from "../../Icons/returnsexchange";
import OrderIssue from "../../Icons/OrderIssue";
import ManageProduct from "../../Icons/ManageProduct";
import Payables from "../../Icons/Payables";
import Settlements from "../../Icons/Settlements";
import { useLazyGetStoreAccessDetailsQuery } from "../../../apis/Seller/SellerReportsAPI.js";
import { useNavigate } from "react-router-dom";
import { showDemandRupifiUrl } from "../../../commonUtils/commonUtils";
import { OpenCloseButton } from "../SellerHeader/NavbarStyled";
import { ReactComponent as HomeblueIcon } from "../../../assets/seller/icons/homeblue.svg";
import SellerRegistration from "../Sellerregisration/SellerRegistration.js";

const { Sider } = Layout;
const { Text } = Typography;

const Sidebar = ({ collapsed, setCollapsed }) => {
  const [isMobileViewport, setIsMobileViewport] = useState(
    typeof window !== "undefined" ? window.innerWidth < 992 : false
  );
  useEffect(() => {
    const onResize = () => setIsMobileViewport(window.innerWidth < 992);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  const [bmpCreditEnable, setBmpCreditEnable] = useState(null);
  const bmp_name = localStorage.getItem("bmp_name") || "";
  const [selectedVendor, setSelectedVendor] = useState(bmp_name);
  const bmp_isactive = localStorage.getItem("bmp_isactive");
  const [isAddNewSellerModalOpen, setIsAddNewSellerModalOpen] = useState(false);
  useEffect(() => {
    const bmpCreditEnableValue = localStorage.getItem("bmp_credit_enable");
    setBmpCreditEnable(bmpCreditEnableValue);
  }, []);
  const bmp_id = localStorage.getItem("bmp_id");
  const url = new URL(`/home/product-search/${bmp_id}`, showDemandRupifiUrl);
  url.searchParams.set("value", bmp_id);
  url.searchParams.set("bmp", bmp_id);
  const navigate = useNavigate();
  const handleNavigateDashboard = () => {
    const currentPath = window.location.pathname;
    const dashboardPath = "/seller/sellerdashboard";
    if (currentPath === dashboardPath) {
      window.location.reload();
    } else {
      navigate(dashboardPath);
    }
  };
  const ArrowTop = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.121"
      height="10.121"
      viewBox="0 0 10.121 10.121"
    >
      <path
        data-name="Line 113"
        transform="translate(1.061 1.061)"
        style={{
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5px",
        }}
        d="m0 8 8-8"
      />
      <path
        data-name="Path 45676"
        d="M7 7h8v8"
        style={{
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5px",
        }}
        transform="translate(-5.939 -5.939)"
      />
    </svg>
  );
  const [selectedMenu, setSelectedMenu] = useState(null);
  const { seller_id } = useParams();
  let { pathname } = useLocation();
  let url_parts = pathname.split("/");
  let new_url = url_parts.slice(0, url_parts.length - 1).join("/");

  const mapAdminIcon = {
    dashboard: <HomeIcon />,
    orders: <OrderIcon />,
    return: <ReturnIcon />,
    requests: <RequestIcon />,
    product: <ManageProduct />,
    sellers: <SellerIcon />,
    reports: <ReportsIcon />,
    accounts: <SettingsIcon />,
    MOBsettlements: <Settlements />,
    customer: <CustomerIcon />,
    forms: <RequestIcon />,

    Payablesrecievables: <Payables />,
    ReturnExchange: <ReturnExchange />,
    OrderIssues: <OrderIssue />,
  };

  const mapSellerIcon = {
    inventoryAndPrice: <MobIcon />,
    catalogue: <SellerIcon />,
    mobLibrary: <MobIcon />,
  };
  const sellerCheck = sellerRoutes.includes(new_url);
  const sellerNavigationItems =
    bmpCreditEnable === "true" ? sellerMenuItems : sellerMenuItemsInActive;
  const mapIcon = sellerCheck ? mapSellerIcon : mapAdminIcon;

  const [getStoreListAPI, { data: StoreList }] =
    useLazyGetStoreAccessDetailsQuery();
  useEffect(() => {
    getStoreListAPI();
  }, [getStoreListAPI]);
  useEffect(() => {
    const menuItems =
      bmpCreditEnable === "true" ? sellerMenuItems : sellerMenuItemsInActive;
    let previousSelectedMenu = null;

    menuItems.forEach((item) => {
      if (item.children) {
        const foundChild = item.children.find(
          (child) => child.path !== "" && pathname.includes(child.path)
        );
        if (foundChild) {
          previousSelectedMenu = foundChild.key;
        }
      } else {
        if (item.path !== "" && pathname.includes(item.path)) {
          previousSelectedMenu = item.key;
        }
      }
    });

    setSelectedMenu(previousSelectedMenu);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  const handleLinkClick = (menuItemKey) => {
    if (selectedMenu === menuItemKey) {
      window.location.reload();
      return;
    }

    setSelectedMenu(menuItemKey);
    if (isMobileViewport) {
      setCollapsed(true);
    }
  };

  const handleVendorChange = (newVendor) => {
    localStorage.setItem("bmp_id", newVendor?.bmp_id);
    localStorage.setItem("bmp_name", newVendor?.vendor_name);
    localStorage.setItem("bmp_isactive", newVendor?.is_active);
    setSelectedVendor(newVendor?.vendor_name);
    window.location.reload();
  };

  const handleAddNewSeller = () => {
    setIsAddNewSellerModalOpen(true);
    setCollapsed(!collapsed);
  };

  const storeDropdownItems = [
    ...(StoreList?.data?.flatMap((seller, index) => [
      {
        key: String(seller?.bmp_id || index),
        label: `${seller?.bmp_id} (${seller?.vendor_name})`,
        onClick: () => handleVendorChange(seller),
      },
      {
        type: "divider",
      },
    ]) || []),
    {
      key: "add-new-seller",
      label: (
        <div className="btn-add-newseller-list">
          <HomeblueIcon /> Add New Store
        </div>
      ),
      onClick: () => handleAddNewSeller(),
    },
  ];

  const handleAddNewSellerModalClose = () => {
    setIsAddNewSellerModalOpen(false);
  };

  const sidebarMenuItems = sellerNavigationItems.map((menuItem) => {
    if (menuItem.children) {
      return {
        key: menuItem.key,
        icon: <RenderIcons value={mapIcon[menuItem.key]} />,
        label: menuItem.label,
        children: menuItem.children.map((submenuItem) => ({
          key: submenuItem.key,
          label: <Link to={submenuItem.path}>{submenuItem.title}</Link>,
          onClick: () => handleLinkClick(submenuItem.key),
        })),
      };
    }

    const linkPath =
      seller_id && sellerRoutes.includes(new_url)
        ? `${menuItem.path}/${seller_id}`
        : menuItem.path;

    return {
      key: menuItem.key,
      icon: <RenderIcons value={mapIcon[menuItem.key]} />,
      label: <Link to={linkPath}>{menuItem.label}</Link>,
      onClick: () => handleLinkClick(menuItem.key),
    };
  });

  return (
    <>
      <Sider
        trigger={null}
        collapsible
        collapsedWidth={isMobileViewport ? 0 : 80}
        collapsed={collapsed}
        theme="light"
        className="left-sidebar"
        style={{
          background: "#fff",
          transition: "all 0.5s ease-in-out 0s",
          border: "solid 1px #d0d0d0",
          overflowX: "hidden",
          overflowY: "auto",
          overscrollBehavior: "contain",
          height: isMobileViewport ? "100vh" : "100%",
          position: isMobileViewport ? "fixed" : "relative",
          top: isMobileViewport ? 0 : "auto",
          left: isMobileViewport ? 0 : "auto",
          zIndex: isMobileViewport ? 1300 : "auto",
        }}
        width={300}
        tabIndex={0}
      >
        {isMobileViewport && (
          <div className="drawer-header" style={{ marginTop: "10px", padding: "0 16px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <OpenCloseButton
                  style={{ color: "#0a243f" }}
                  onClick={() => setCollapsed(!collapsed)}
                >
                  {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                </OpenCloseButton>
                <Logo
                  style={{
                    cursor: "pointer",
                    width: "88px",
                    marginLeft: "10px",
                    marginBottom: "6px",
                  }}
                  onClick={handleNavigateDashboard}
                />
              </div>
              <Dropdown
                menu={{ items: storeDropdownItems }}
                trigger={["click"]}
                getPopupContainer={(trigger) => document.body}
                overlayStyle={{ zIndex: 1050 }}
              >
                <div
                  className="fixed-font font-eclipse cls-top-seller-menu"
                  style={{ cursor: "pointer", marginLeft: "16px" }}
                >
                  {selectedVendor}{" "}
                  <DownOutlined className="profile-dropdown-styled-cursor" />
                </div>
              </Dropdown>
            </div>
          </div>
        )}
        <Menu
          mode="inline"
          defaultSelectedKeys={[selectedMenu]}
          selectedKeys={[selectedMenu]}
          items={sidebarMenuItems}
          style={{
            marginTop: "24px",
            fontFamily: "Inter",
            fontSize: "16px",
            fontWeight: "500",
            border: "none",
            background: "#fff",
            transition: "all 0.5s ease-in-out 0s",
            left: 0,
            top: 68,
            bottom: 0,
          }}
        />
        {isMobileViewport && bmp_isactive === "true" && (
          <Row>
            <Col>
              <div className="nav-item staticcontent enabled support-text">
                <div className="mb-1 support-style-text">Store timings</div>

                <>
                  <Badge size="small">
                    <a href={url.href} rel="noreferrer" target="_blank">
                      <Text className="online-store sidebar-online-store-text">
                        Your online store {ArrowTop}
                      </Text>
                    </a>
                  </Badge>
                </>
              </div>
            </Col>
          </Row>
        )}
        {!collapsed && (
          <Row>
            <Col>
              <div className="nav-item staticcontent enabled support-text">
                <div className="mb-1 support-style-text">Support :</div>
                <a
                  href="tel:8660423608"
                  className="mt-2 telephone-number-left mail-top-style"
                >
                  {" "}
                  +91 8660423608{" "}
                </a>
                <a
                  href="mailto:ask@madoverbuildings.com"
                  className="telephone-number-left"
                >
                  ask@madoverbuildings.com{" "}
                </a>
              </div>
            </Col>
          </Row>
        )}
      </Sider>
      {isMobileViewport && !collapsed && (
        <div
          className="seller-sidebar-mask"
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: 1250,
            background: "rgba(0, 0, 0, 0.45)",
            opacity: collapsed ? 0 : 1,
            transition: "opacity 0.3s",
            display: `${collapsed ? "none" : "block"}`,
          }}
          onClick={() => setCollapsed(true)}
        ></div>
      )}
      <Modal
        title="Add New Store"
        open={isAddNewSellerModalOpen}
        onCancel={handleAddNewSellerModalClose}
        footer={[]}
      >
        <SellerRegistration
          handleAddNewSellerModalClose={handleAddNewSellerModalClose}
          reloadAPI={getStoreListAPI}
        />
      </Modal>
    </>
  );
};
export default Sidebar;
